import { redux } from 'Core/redux';
import { STORE_KEY, INITIAL_STATE } from './slice';

export const selectWaterTowers = state => {
  const appState = state || redux.store.getState();
  return appState?.[STORE_KEY] || INITIAL_STATE;
};

export const selectWaterTowersData = state => selectWaterTowers(state).data;
export const selectWaterTowersLoading = state => selectWaterTowers(state).loading;
export const selectWaterTowersError = state => selectWaterTowers(state).error;
export const selectWaterTowersMaintenanceRecordsData = state => selectWaterTowers(state).maintenanceRecordsData;
export const selectMaintenanceRecordData = state => selectWaterTowers(state).maintenanceRecordData;
export const selectWaterTowersMaintenanceData = state => selectWaterTowers(state).maintenanceData;
export const selectCellHistoryData = state => selectWaterTowers(state).cellHistoryData;
export const selectTileView = state => selectWaterTowers(state).tileView;
